import { useState } from 'react';

const faqs = [
  {
    q: '91免费上的影视资源真的全部免费吗？',
    a: '是的，91免费聚合的全网影视资源均来自公开合法的免费在线视频平台，用户无需注册、无需付费即可直接在线观看高清电影和热门剧集。我们每日更新资源链接，确保观影通道畅通。',
  },
  {
    q: '如何找到想看的免费电影？',
    a: '你可以通过首页的专题合集按类型快速浏览，也可以查看热门排行发现大家都在看的影片。我们按动作、喜剧、悬疑、科幻等分类整理，还提供搜索索引，帮你精准定位心仪的免费电影在线观看入口。',
  },
  {
    q: '支持哪些设备观看？',
    a: '91免费全面适配电脑、平板和手机端，无需下载任何软件或插件，打开浏览器即可流畅观看高清视频免费看。我们优化了移动端观影体验，小屏也能享受1080P画质。',
  },
  {
    q: '视频播放卡顿怎么办？',
    a: '我们为每部影片提供多条播放线路，当某条线路加载缓慢时，可以手动切换到其他线路。建议在网络稳定的环境下观看，使用 Chrome 或 Safari 等主流浏览器可获得最佳播放体验。',
  },
  {
    q: '资源多久更新一次？',
    a: '91免费团队每日持续追踪全网最新资源，院线新片上线流媒体后会在24小时内收录，热门剧集同步更新。平台每日平均新增50部以上免费电影和在线视频资源，确保你不错过任何精彩内容。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100/80 text-secondary-700 text-sm font-medium mb-4 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            你关心的都在这里
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
              >
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                  openIndex === i ? 'bg-primary-100 rotate-180' : 'bg-background-200'
                }`}>
                  <i className={`ri-arrow-down-s-line text-lg ${openIndex === i ? 'text-primary-500' : 'text-foreground-500'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-5 md:pb-6 text-foreground-600 text-sm md:text-base leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}